export function setupFileLinks(): void {
    const pdfLinks = document.querySelectorAll('[href*=".pdf"]');

    pdfLinks.forEach((link) => {
        link.insertAdjacentHTML('beforeend', '<span class="sr-only"> opens a PDF</span>');
    });
}
